<div class="p-12">
  <div class="p-12">

    <mat-table [dataSource]="forms" class="mat-elevation-z8">
      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef> Form. </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.id}} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.name }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef> Description </mat-header-cell>
        <mat-cell *matCellDef="let element">{{element.description }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="fee">
        <mat-header-cell *matHeaderCellDef> File Fee </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ centsToDollars(element.fee) }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-raised-button color="accent" (click)="makeNewCase(element.id)">
            <span>FILE</span>
          </a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/content/common/new-petition/new-petition.component.html